import { API } from "@project/shared"

export const getOccupations = async () => API.get(`/occupations`)
